import _Image from './Image';

import './style/index.js';

export type { ImageProps } from './Image';
export * from './type';

export const Image = _Image;
export default Image;
